import { fromEvent } from 'rxjs';
import { pluck,filter,debounceTime,tap } from 'rxjs/operators';

export class CreateAccountPopup {
    constructor(selector) {
        this._selector = selector;
        this.isUsernameValid = false;
        this.isRequestInProgress = false;
        this.enteredUsername = null;
        this.enteredPassword = null;
        this.avatarId =  0;
        this.referralCode = jQuery('.referral-code').data('referral-code');
        this.initlialiseSelectors();
        this.attachListeners();
        this.inputSlide();
        this.validateUsername();
        const that = this;
        let userNameInputObserver = fromEvent(this._userNameInput, "input")
            .pipe(
                tap(function (event) {
                that.markUsernameValidating();
                return event;
                }),
                pluck('target', 'value'),
                debounceTime(1000),
                filter((userName) => {
                if (userName.length > 2) {
                    return true;
                } else {
                    this.isUsernameValid = false;
                    this.markUsernameInvalid();
                    this.disableAgreeBtn();
                    return false;
                }
                })
            );


        userNameInputObserver.subscribe(function (userName) {
            let request = jQuery.ajax({
                type: "POST",
                url: `/${document.documentElement.lang}/${userName}/validate`
            });
            request.done(function(data) {
                if(data.username_suggestions != null) {
                that.suggestUserNames(data.username_suggestions)
                }
                else if ((data.error != "" &&  data.error != undefined ) && data.username_suggestions == null){
                    that.errorMsgUsernameInvalid()
                }
                else {
                that.processUserName(userName);
            }
        });
        });

        let passwordInputObserver = fromEvent(that._passwordInput, "input")
        .pipe(
            tap(function (event) {
            that.markPasswordValidating();
            return event;
            }),
            pluck('target', 'value'),
            debounceTime(1000),
            filter(function (password) {
            return that.getPasswordStatus(password);
            })
        );

        passwordInputObserver.subscribe(function (password) {
            that.processPassword(password);
        });

        if (this.welcomePage()) {
            this.displayPopup();
        }

        window.initHeroAnim()
    }

    validateUsername(){
       const that = this;
       that._userNameInput.on("keypress", function (event) {
            if(event.which === 32){
                return false;
            }
            var character = String.fromCharCode(event.keyCode);
            return that.isInputForbidden(character);
        });
    }

    inputSlide(){
        const that = this
        that._userNameInput.on("focus", function () {
            that._passwordHelpTxt.slideUp(200, function () { that._passwordGroup.removeClass("focus") });
            that._usernameGroup.addClass("focus");
            that._usernameHelpTxt.slideDown(200);
        });

        that._passwordInput.focus(function () {
            that._usernameHelpTxt.slideUp(200, function () { that._usernameGroup.removeClass("focus") });
            that._passwordGroup.addClass("focus");
            that._passwordHelpTxt.slideDown(200);
        });
    }

    welcomePage() {
        const welcomePageRegex = RegExp('/welcome');
        let currentLocationPath = document.location.pathname;
        return welcomePageRegex.test(currentLocationPath);
    }

    initlialiseSelectors(){
        this._login_popup = jQuery(this._selector.loginPopup);
        this._link = jQuery(this._selector.link);
        this._form = jQuery(this._selector.form);
        this._popup = jQuery(this._selector.popup);
        this._confirmation = jQuery(this._selector.confirmation);
        this._submit_button = jQuery("input[type=submit]", this._popup);
        this._thumbnails = jQuery(".thumbnail");

        this._userNameInput = jQuery("#sign-up-form-username")
        this._passwordInput = jQuery("#sign-up-form-password")
        this._passwordGroup = jQuery(".password-group")
        this._usernameGroup = jQuery(".user-name-group")
        this._usernameHelpTxt = jQuery(".user-name-group .help-txt")
        this._passwordHelpTxt = jQuery(".password-group .help-txt")
        this._agreeBtn = jQuery(".agree-btn");
        this._errorMsgs = jQuery(".error-tip")
        this._namesSuggestionsSection = jQuery(".name-suggestions-section")
        this._errorMsgUsernameInvalid = jQuery(".error-tip.un-invaild")
        this._nameSuggestionList = jQuery(".name-suggestion-list"),
        this._errorMsgUsernameTaken = jQuery(".error-tip.un-taken"),

        this.isUsernameValid = false
        this._isPasswordValid = false
        this.isRequestInProgress = false
        this._submitSpinner = jQuery(".submit-spinner");
    }

    updateAvatarSelection(avatarId) {
        this.avatarId = avatarId;
        this._thumbnails.removeClass("highlight");

        jQuery("a[data-avatar-id=" + avatarId + "]").addClass("highlight");
        if (exportRoot) {
            exportRoot.mc_avatar_anim.gotoAndStop('avatar'+avatarId)
        }
    }

    markPasswordValidating() {
        this._passwordGroup.removeClass("invalid valid");
        this._passwordGroup.addClass("validating");
    }

    getPasswordStatus(password) {
        if (password.length > 5) {
            this._isPasswordValid = true
            return true;
        } else if (password.length === 0) {
            this.resetPassword();
            this.disableAgreeBtn();
            this.hideSpinner();
            this._isPasswordValid = false;
            return false;
        } else {
            this._isPasswordValid = false;
            this.markPasswordInvalid();
            this.disableAgreeBtn();
            this.hideSpinner();
            return false;
        }
    }

    resetPassword() {
        this._passwordGroup.removeClass("invalid valid validating");
    }

    markPasswordInvalid() {
        this._passwordGroup.removeClass("valid validating");
        this._passwordGroup.addClass("invalid");
        this._passwordInput.trigger('focus')
    }

    markPasswordValid() {
        this._passwordGroup.removeClass("invalid validating");
        this._passwordGroup.addClass("valid");
        this._isPasswordValid = true;
    }

    disableAgreeBtn() {
        this._agreeBtn.removeClass("checked");
        this._agreeBtn.addClass("disabled");
    }

    hideSpinner() {
        this._submitSpinner.removeClass("show");
    }

    onSubmit(that) {
        if (that.getFormStatus) {
            that.isRequestInProgress = true;
        }
    }

    getFormStatus() {
        return this.isUsernameValid && this._isPasswordValid;
    }

    showSpinner() {
        this._submitSpinner.removeClass("show");
        this._submitSpinner.addClass("show");
    }

    disableBackButton() {
        jQuery(".nav_back_btn").removeClass("disabled");
        jQuery(".nav_back_btn").addClass("disabled");
    }

    processPassword(password) {
        this._isPasswordValid = false;
        this.disableAgreeBtn();
        this.enteredPassword = password;
        if (this.isPasswordForbidden(password)) {
          this.markPasswordInvalid();
        } else {
          this.markPasswordValid();
          if (this.getFormStatus()) {
            this._agreeBtn.on("click", this.onSubmit(this));
            this.enableAgreeBtn();
          }
        }
    }

    isPasswordForbidden(password) {
      return this.isProhibited(password) ||
        (this.enteredUsername ? this.usernameMatchesPassword(this.enteredUsername, password) : false);
    }

    usernameMatchesPassword(username, password) {
      username = username.toLowerCase();
      password = password.toLowerCase();
      return username.includes(password) || password.includes(username)
    }

    isProhibited(password) {
      password = password.toLowerCase();
      return password.toLowerCase().includes('password')
    }

    enableAgreeBtn() {
      this._agreeBtn.removeClass("disabled");
    }

    attachListeners() {
        const that = this;
        this._link.on('click', function (event) {
            event.stopImmediatePropagation();
            event.preventDefault();
            that.displayPopup();
        })

        jQuery(".pop-close-btn", this._popup).click(function() {
            that.resetCreateAccountForm()
            that._popup.css({"display":"none"});
        });

        this._thumbnails.click(function (event) {
            let selectedAvatarID = jQuery(this).data("avatar-id");
            that.updateAvatarSelection(selectedAvatarID);
        });
        this._thumbnails[Math.floor(Math.random() * (this._thumbnails.length))].click();

        jQuery(".next-btn, .nav_back_btn").click(function () {
            jQuery(".sign-up-panel.avatar-thumbnails").fadeToggle();
            jQuery(".sign-up-panel.create-login").fadeToggle();
            jQuery("#sign-up-form-username").focus();
        });

        jQuery(".username-tips-link").click(function (event) {
            event.preventDefault();
            jQuery(".username-tips-popup").show();
            jQuery(".username-tips-popup .popup").show();
            jQuery("body").addClass("pop-open-no-scroll");
        });

        jQuery(".username-tips-popup .pop-close-btn").click(function (event) {
            event.preventDefault();
            jQuery(".username-tips-popup").hide();
        });

        jQuery(".checkbox-icn").click(function (event) {
            if(!(that._agreeBtn.hasClass("disabled"))){
                that._agreeBtn.addClass("checked");
                that.showSpinner();
                that.disableBackButton();
                that.registerUser();
            }
        });
    }

    registerUser() {
        let params = {
                screen_name: this.enteredUsername,
                password: this.enteredPassword,
                avatar_id: this.avatarId,
            }

        if (this.referralCode) {
            params.referral_code = this.referralCode
        }
        let deferredObj = jQuery.Deferred();
        let request = jQuery.ajax({
            type: "POST",
            url: `/${document.documentElement.lang}/register`,
            dataType: 'json',
            data: params
        });
        request.done(function(response) {
            deferredObj.resolve();
            jQuery.cookie('authorization_token', response.data.authorization_token, { expires: 1, path: '/' })
            window.top.location.href = '/'+ document.documentElement.lang +'/game/play';
        })
    }

    suggestUserNames(suggestedUserName) {
        const that = this
        jQuery(".submit-spinner").removeClass("show");
        that.disableAgreeBtn();

        if (suggestedUserName[0] === "0") {
          that.processUserName(enteredUsername);
        }
        else if ( suggestedUserName[0] === ""){
            that.errorMsgUsernameTaken();
            that.markUsernameInvalid();
        }
        else {
          that.errorMsgUsernameTaken();
          that.markUsernameInvalid();
          this._nameSuggestionList.empty();

          for (var i = 0; i < suggestedUserName.length - 1; i++) {
            let suggestedNameList= "<li id="+"suggested-name-" + (i + 1) + ">" + suggestedUserName[i] + '</li>'
            this._nameSuggestionList.append(suggestedNameList);
          }

          this._nameSuggestionList.on("click", "li", function () {
            this.enteredUsername = jQuery(this).text();
            this._userNameInput = jQuery("#sign-up-form-username")
            this._userNameInput.val(this.enteredUsername);
            that.processUserName(this.enteredUsername);
            that.errorMsgsHide();
            that.hideNameSuggestions();
            that.markUsernameValid();

            if (that.enteredPassword) {
                that.markPasswordValidating();
                that.processPassword(that.enteredPassword);
            }
          });

          that.showNameSuggestions();
        }
      }

    showNameSuggestions() {
    this._namesSuggestionsSection.slideDown();
    }

    processUserName(userName){
        const that = this;
        that.isUsernameValid = false;
        that.disableAgreeBtn();
        that.errorMsgsHide();
        that.hideNameSuggestions();
        userName.length > 0 ? that.markUsernameValidating() : that.resetUsername();

        let enteredUsername = userName.replace(/[~`_.!@#$%\^&*()+=\-\[\]\\';,/{}|\\":<>\?\s+]/g, "");
        that.enteredUsername = enteredUsername.charAt(0) + enteredUsername.slice(1).toLowerCase();
        let userNameInput = jQuery("#sign-up-form-username")
        userNameInput.val(that.enteredUsername);
        that.markUsernameValid()
        if (that.enteredPassword) {
            that.processPassword(that.enteredPassword);
        }
    }

     errorMsgUsernameInvalid() {
        const that = this;
        that.errorMsgShow(this._errorMsgUsernameInvalid);
        that.hideNameSuggestions();
        that.markUsernameInvalid();
      }

    errorMsgsHide() {
        this._errorMsgs.fadeOut();
    }

    hideNameSuggestions() {
        this._namesSuggestionsSection.slideUp(300);
    }

    markUsernameValidating() {
        this._usernameGroup.removeClass("invalid valid").addClass("validating");
    }

     resetUsername() {
        this._usernameGroup.removeClass("invalid valid validating");
      }

    markUsernameInvalid() {
        this._usernameGroup.removeClass("valid validating");
        this._usernameGroup.addClass("invalid");
    }

    getAccountLanguageCode() {
        let languageCode = {
            en: 0,
            es: 1,
            pt: 2,
            fr: 3,
            de: 4,
        };
        let accountLanguage = typeof flashvars !== "undefined" ? flashvars.locale : "en"
        return languageCode[accountLanguage];
    }

    isInputForbidden(input) {
        return !/[~`_.!@#$%\^&*()+=\-\[\]\\';,/{}|\\":<>\?]/g.test(input);
    }

    displayPopup() {
        this._login_popup.removeClass("show");
        this._popup.css({"display":"block"});
        jQuery('.popup', this._popup).css({"display":"block"});
        this._form.show();
        this._confirmation.hide();
        jQuery('#forgot-password-form').show();
    }

    getFormStatus() {
        return this.isUsernameValid && this._isPasswordValid;
    }

    errorMsgUsernameTaken() {
        const that = this
        that.errorMsgShow(this._errorMsgUsernameTaken);
    }

    errorMsgShow(targetMsg) {
        const that = this
        that.errorMsgsHide();
        targetMsg.fadeIn();
    }

    markUsernameValid() {
        this._usernameGroup.removeClass("invalid validating");
        this._usernameGroup.addClass("valid");
        this.isUsernameValid = true;
      }

    resetCreateAccountForm() {
        this._userNameInput.val("");
        this._passwordInput.val("");
        this._usernameGroup.removeClass("invalid valid validating");
        this._passwordGroup.removeClass("invalid valid validating");
        this._agreeBtn.addClass("disabled");
    }

    static setup(selector) {
        return new CreateAccountPopup(selector);
    }
}